module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg-97d1f3f86f6753d09e1410f9040cc334.jpg";